export const LIBRARY_ROOT = '/library'

export const LIBRARY_PAGE_TAB_TITLE = 'Library'
